/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

interface TextCollapseProps {
  isHidden: boolean;
  height: number;
}

const defaultHeight = 55;

export const useTextCollapse = (props: TextCollapseProps) => {
  const { isHidden, height } = props;
  const isTruncatedText = height > defaultHeight;
  
  const getHeight = () => {
    switch (true) {
      case (isTruncatedText && isHidden):
        return `${defaultHeight}px`;
      default:
        return `${height}px`;
    }
  };

  const getClass = () => {
    if (!isTruncatedText) {
      return '';
    }
    if (isHidden) {
      return 'is-truncated collapsed';
    }
    return 'is-truncated expanded';
  };

  return { height: getHeight(), instructionClass: getClass(), isTruncated: isTruncatedText };
};
